<template>
  <div class="navigation" :class="{ navigation_inactive: !sidebarIsOpened }">
    <div class="navigation__inner">
      <Logo class="navigation__logo" :state="sidebarIsOpened" />
      <nav class="navigation__nav">
        <btn-wrapper
          v-for="(item, index) in navigation"
          :key="index"
          :params="{
            activeClass: 'bg-default/10',
            class: 'navigation__link group hover:bg-default/10',
            type: 'link',
            path: `${item.path}`,
            isSlotIsset: true,
          }"
        >
          <svg class="icon icon_color_gray navigation__icon group-hover:fill-default group-hover:stroke-default">
            <use :xlink:href="item.icon"></use>
          </svg>
          <Transition name="navigation__fade">
            <div class="navigation__item group-hover:text-default" v-if="sidebarIsOpened">
              {{ item.text }}
            </div>
          </Transition>
        </btn-wrapper>
      </nav>
      <Transition name="navigation__fade">
        <div class="navigation__courses" v-if="sidebarIsOpened">
          <h3 class="title title_color_light navigation__title">
            {{ $t("leftSidebar.myCourses") }}
          </h3>
          <div class="navigation__courses-wrp">
            <btn-wrapper
              v-for="(item, index) in courses"
              :key="index"
              :params="{
                activeClass: 'bg-default/10 text-default fill-default stroke-default',
                class: 'navigation__link group hover:bg-default/10 hover:fill-default',
                type: 'link',
                path: `/course/${item.id}`,
                isSlotIsset: true,
              }"
            >
              <svg class="icon navigation__icon group-hover:fill-default group-hover:stroke-default">
                <use
                  xlink:href="/img/sprites/icons-sprite.svg#icon-course"
                ></use>
              </svg>
              <div class="navigation__item navigation__course group-hover:text-default">
                {{ item.displayname }}
              </div>
            </btn-wrapper>
          </div>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import Logo from "@/components/UI/logo/index.vue";

const store = useStore();
const sidebarIsOpened = computed(() => store.getters.sidebarIsOpened);
const courses = ref([]);
const { t } = useI18n();
const navigation = computed(() => [
  // {
  //   icon: "/img/sprites/icons-sprite.svg#icon-home",
  //   text: t("leftSidebar.home"),
  //   path: "/home",
  // },
  {
    icon: "/img/sprites/icons-sprite.svg#icon-user",
    text: t("leftSidebar.lk"),
    path: "/cabinet",
  },
  {
    icon: "/img/sprites/icons-sprite.svg#icon-calendar",
    text: t("leftSidebar.cal"),
    path: "/calendar",
  },
  {
    icon: "/img/sprites/icons-sprite.svg#icon-course",
    text: t("leftSidebar.courses"),
    path: "/courses",
  }
]);
const getCourses = () => {
  store.dispatch("getUserEnrolledCourses", store.getters.user?.id).then((res) => {
    if(res.errorcode) return
    courses.value = res.sort((x, y) => {
      return x.startdate - y.startdate;
    });
  });
};
getCourses()
watch(() => store.state.auth.user, () => {
    getCourses();
})
</script>

<style lang="scss" scoped>
@import "./scss/navigation.scss";
</style>
